import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { Moment } from 'moment';
import { TerraUtils } from '../../TerraUtils';
import moment from 'moment';

export const YEAR_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'terra-date-picker-year',
  templateUrl: './date-picker-year.component.html',
  styleUrls: ['./date-picker-year.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers:[
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMATS },
  ]
})
export class DatePickerYearComponent implements OnInit {
  readonly today = new Date();

  @Input() control:UntypedFormControl;
  @Input() label:string;
  @Input() startAt:string = '1980-01-01';
  @Input() min:string = '1900-01-01';
  @Input() max:Date = this.today;

  TerraUtils = TerraUtils;

  idRnd = TerraUtils.makeid();
  
  constructor() { }

  ngOnInit(): void {
  }

  chosenYearHandler(normalizedYear: Moment, dp: any) {
    this.control.setValue(moment().startOf('year').year(normalizedYear.year()));
    dp.close();
  }

}
